var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGrid = function SvgGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5v10h10V5H5zm12 0v10h10V5H17zM7 7h6v6H7V7zm12 0h6v6h-6V7zM5 17v10h10V17H5zm12 0v10h10V17H17zM7 19h6v6H7v-6zm12 0h6v6h-6v-6z"
  })));
};
export default SvgGrid;